let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7NfA4")).then(() => parcelRequire('aKfhH'));